import type { Action } from 'react-sweet-state';

import type { FormRendererState } from '../../types';

export const clearModifiedValues =
	(): Action<FormRendererState> =>
	({ setState }) => {
		setState({
			modifiedValues: {},
		});
	};
